import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Box } from '@material-ui/core';
import { BOWTIE_PINK } from '@bowtie-ins/bowkit/palette';

const dotTada = keyframes`
  0% {
    transform: scale(1);
  }
  10%, 20% {
    transform: scale(0.9);
  }
  30%, 50%, 70%, 90% {
    transform: scale(1.1);
  }
  40%, 60%, 80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

const AnimatedDotBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'visible',
})<{ visible: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${BOWTIE_PINK};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s 0.5s ease-out;
  animation: ${dotTada} 1s infinite;
`;

interface AnimatedDotProps {
  visible?: boolean;
}

const AnimatedDot: React.FC<AnimatedDotProps> = ({ visible = true }) => {
  return <AnimatedDotBox visible={visible} />;
};

export default AnimatedDot;
